import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { LoaTrackerView } from '../components/views/loaTrackerView'
import { Page, PageHeader } from '../ui'

function LoaTracker() {
    return (
        <div className="loaTracker">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Sentinel Tools"
                        title="LOA Tracker"
                        intro="Operational list of portal LOA links. Filter by signed status and when the link was created."
                    />
                    <LoaTrackerView />
                </Page>
            </MainView>
        </div>
    )
}

export default LoaTracker
